<template>
  <div class="body">
    <div class="title">
      查看详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item class="dsadf">信息管理</el-breadcrumb-item>
          <el-breadcrumb-item class="dsadf" :to="{ path: '/jubaoguanli' }">举报管理</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-card  class="cardpsad">
      <el-row>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">
              举报信息
            </div>
            <div>
              <el-form class="demo-form-inline" :label-position="labelPosition" @submit.native.prevent>
                <el-form-item label="反馈者" label-width="116px">
                  <div class="flexsaa">
                    <img :src="Query.tips_facepic" alt="" class="imgs" :onerror="defaultImg">
                    {{Query.tips_realname}}
                    <button class="huiyuanziliao" @click="openhuiyuan">会员资料</button>
                  </div>
                </el-form-item>
                <el-form-item label="反馈原因" label-width="116px">
                  {{ Query.reason }}
                </el-form-item>
                <el-form-item label="反馈图片" label-width="116px">
                  <img :src="Query.tips_pics" alt="" class="imgs" :onerror="defaultImg">
                </el-form-item>
                <el-form-item label="反馈描述" label-width="116px">
                  {{ Query.remark }}
                </el-form-item>
                <el-form-item label="联系人" label-width="116px">
                  {{ Query.tips_realname }}
                </el-form-item>
                <el-form-item label="联系电话" label-width="116px">
                  {{Query.tips_usermobile}}
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">
              状态信息
            </div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="帖子ID " label-width="116px">
                {{Query.post_id }}
              </el-form-item>
              <el-form-item label="提交时间 " label-width="116px">
                {{Query.apply_realname }}
              </el-form-item>
              <el-form-item label="受理状态" label-width="116px" :style="{'color': (Query.post_status === 0 ? '#cccccc':'#0FA838')}">
                {{Query.tips_usermobile === 1 ?'下架':'上架' }}
              </el-form-item>
              <el-form-item label="受理时间" label-width="116px">
                {{Query.apply_mobile }}
              </el-form-item>
              <el-form-item label="受理情况备注" label-width="116px">
                {{Query.apply_mobile }}
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <vxe-modal width="579" ref="huiyuan" height="622" size="small" :show-footer="false" title="会员资料" :show-close="true">
      <div class="huiyuan">
        <el-form class="demo-form-inline" :label-position="labelPosition" style="margin-top: 60px; margin-left: 60px">
          <el-form-item label="头像" label-width="116px">
            <div class="flexsaa">
              <img :src="Query.tips_facepic" alt="" class="imgs" :onerror="defaultImg">
            </div>
          </el-form-item>
          <el-form-item label="姓名" label-width="116px">
            <div class="flexsaa">
              {{Query.tips_realname}}
            </div>
          </el-form-item>
          <el-form-item label="手机号码" label-width="116px">
            <div class="flexsaa">
              {{Query.tips_usermobile}}
            </div>
          </el-form-item>
          <el-form-item label="注册时间" label-width="116px">
            <div class="flexsaa">
              {{Query.tips_userregtime}}
            </div>
          </el-form-item>
          <el-form-item label="发帖数" label-width="116px">
            <div class="flexsaa">
              {{Query.tips_userpostnum}}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { posttipsView } from '@/api/xinxi'
export default {
  name: 'index',
  computed: {
    ...mapState(['jubaoID']),
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  created () {
    console.log('shangxiehuixiangqing', this.jubaoID)
    this.xiangqing()
  },
  data () {
    return {
      labelPosition: 'left',
      Query: {},
      pic: [],
      remark: ''
    }
  },
  methods: {
    openhuiyuan () {
      this.$refs.huiyuan.open()
    },
    xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token'),
        tips_id: this.jubaoID
      }
      posttipsView(obj).then(({ data: res }) => {
        console.log('resss', res)
        this.Query = res
      })
    }
  }
}
</script>

<style scoped lang="less">
.flexsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  .huiyuanziliao{
    margin-left: 13px;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    background: white;
    border-radius: 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.tongguo{
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#1bb745, #17ab3f);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border: none;
}
.mb{
  margin-right: 10px;
}
.jujue{
  border: none;
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#e54848, #d54141);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.rou{
  display:flex;
  flex-direction: row;
}
.fxrowccsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 400px;
  .imgsccccss{
    width: 100px;
    height: 100px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: inline-block;
    .imgscc33{
      width: 100%;
      height: 100%;
    }
  }
}
.imgscc{
  width: 100px;
  height: 100px;
}
.body {
  display: flex;
  flex-direction: column;
  .cardpsad{
    padding:40px 50px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
  }
  .wenbenyu{
    width: 370px;
  }
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }

  }
  .fromdsadas{
    display:flex;
    flex-direction: column;
    .tiile{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      text-align: left;
      color: #2e2e2e;
      letter-spacing: 0px;
      margin-bottom: 42px;
    }
  }
}
</style>
